/*****************************************
 * * IMPORTS
 *****************************************/
// React libraries
import React, { Component } from 'react';

// styles and images
import playImg from '../../assets/icons/play.svg';
import pauseImg from '../../assets/icons/pause.svg';
import repeatImg from '../../assets/icons/repeat.svg';
import plusImg from '../../assets/icons/plus.svg';
import minusImg from '../../assets/icons/minus.svg';
// import spinImg from '../../assets/icons/spin.webp';
import fullScreenIcon from '../../assets/icons/full-screen.svg';
import fullScreenExitIcon from '../../assets/icons/full-screen-exit.svg';

import styles from './Main.module.css';

// components
import Canvas from '../canvas/Canvas';
import Select from '../buttons/Select';
import ImgBtn from '../buttons/ImgBtn';
import SimpleBtn from '../buttons/SimpleBtn';
import Input from '../buttons/NumberInput';
import StepSlider from '../buttons/StepSlider';

// code
import data, { uiData } from '../../logic/data';
import { restart, play, step } from '../../logic/process';
import { simInit } from '../../logic/simulation';

/*****************************************
 * * CREATE COMPONENT
 *****************************************/

class Main extends Component {
  mainRef = React.createRef();
  canvasRef = React.createRef();

  state = {
    exampleIdx: data.exampleIdx,
    playState: 'pause',
    clickDisable: false,
    fullScreen: false,
    fullScreenIcon: fullScreenIcon,
    numOfBalls: data.numOfBalls,
    sickProbability: data.sickProbability,
    maxSpeed: data.maxSpeed,
    wallY: data.wallY,
    wallWidth: data.wallWidth,
  };

  // after component is rendered
  componentDidMount = () => {
    this.setCanvas();

    restart.bind(this)(false);
  };

  setCanvas = () => {
    const canvas = this.canvasRef.current;
    const width = canvas.clientWidth;
    const height = canvas.clientHeight;
    const size = { width, height };

    this.setState(state => ({ size, data: simInit(size, state) }));
  };

  componentWillUnmount = () => {
    clearInterval(this.intervalID);
  };

  // change pay/pause state
  // must be arrow because of this
  changePlayState = val => this.setState({ playState: val });

  // play/pause was clicked
  handlePlayClick = () => play.bind(this)();

  // disable/enable play click on transitions
  setPlayClickDisable = val => this.setState({ playClickDisable: val });

  // text button
  handleBtnClick = (idx, val) => {
    this.changePlayState('pause');
    if (val === 'step') {
      setTimeout(step.bind(this), 0);
    }
  };

  handleInputChange = (idx, val) => {
    if (idx === 0) {
      this.setState({ numOfBalls: val });
    } else {
      this.setState({ sickProbability: val });
    }
    this.handleExampleChange(this.state.exampleIdx);
  };

  // slider handlers

  // slider value change
  handleSliderChange = val => {
    this.setState({ maxSpeed: val });
    // restart the process
    this.handleExampleChange(this.state.exampleIdx);
  };

  // slider minus/plus handlers
  handleMinusClick = () => {
    let maxSpeed = this.state.maxSpeed;
    if (maxSpeed > uiData.sliderMin) {
      maxSpeed -= uiData.sliderStep;
    }
    this.handleSliderChange(maxSpeed);
  };

  handlePlusClick = () => {
    let maxSpeed = this.state.maxSpeed;
    if (maxSpeed < uiData.sliderMax) {
      maxSpeed += uiData.sliderStep;
    }
    this.handleSliderChange(maxSpeed);
  };

  // change playing example
  handleExampleChange = val => {
    // console.log('[EXAMPLE]', val);
    this.props.onExampleChange(val);
    this.setState({
      exampleIdx: val,
      wallY: data.wallY,
    });
    this.setCanvas();
    setTimeout(restart.bind(this), 300);
  };

  // restart playing from start on the same example
  handleRepeatClick = () => {
    this.handleExampleChange(this.state.exampleIdx);
  };

  handleFullScreen = () => {
    this.setState(state => ({
      fullScreenIcon: state.fullScreen ? fullScreenIcon : fullScreenExitIcon,
    }));
    this.mainRef.current.classList.toggle(styles['fullScreen']);
    this.setState(state => ({ fullScreen: !state.fullScreen }));

    this.handleExampleChange(this.state.exampleIdx);
  };

  // HTML code
  render() {
    const playPauseImg = this.state.playState === 'play' ? pauseImg : playImg;

    return (
      <main className={styles.main} ref={this.mainRef}>
        {/* {this.state.busy && <Spinner />} */}

        {/* canvas */}
        <div ref={this.canvasRef} className={styles.canvas}>
          <Canvas
            ref={this.canvasRef}
            title={data.canvasTitle}
            data={this.state.data}
            wallY={this.state.wallY}
            wallWidth={data.wallWidth}
            fullScreen={this.state.fullScreen}
            size={this.state.size}
          />
        </div>
        {/* inputs */}

        {/* slider */}
        <div className={styles.slider}>
          <ImgBtn src={plusImg} onClick={this.handlePlusClick} small={true} />
          <StepSlider
            title={uiData.sliderTitle}
            onChange={this.handleSliderChange}
            marks
            min={uiData.sliderMin}
            max={uiData.sliderMax}
            step={uiData.sliderStep}
            value={this.state.maxSpeed}
            valueLabelDisplay='on'
          />
          <ImgBtn src={minusImg} onClick={this.handleMinusClick} small={true} />
        </div>

        {/* input buttons */}
        <div className={styles.inputs}>
          <ImgBtn src={playPauseImg} onClick={this.handlePlayClick} />
          <ImgBtn src={repeatImg} onClick={this.handleRepeatClick} />
          {/* <ImgBtn src={stepImg} onClick={this.onStepClick} title="step" /> */}
          {/* text buttons */}
          {/* {uiData.buttons.map((btn, idx) => {
            let disabled = false;
            return (
              <SimpleBtn
                key={idx}
                obj={btn}
                disabled={disabled}
                onClick={this.handleBtnClick.bind(this, idx)}
              />
            );
          })} */}

          <div className={styles.count}>
            {uiData.inputBoxes.map((inp, idx) => (
              <Input
                key={idx}
                obj={inp}
                onChange={val => this.handleInputChange(idx, val)}
                // dataToolTip={`W${idx+1}`}
              />
            ))}
          </div>

          {/* example selection */}
          {/* <Select
            options={uiData.selectExample}
            selectedIdx={this.state.exampleIdx}
            onSelectChange={this.handleExampleChange}
          /> */}
          <img
            src={this.state.fullScreenIcon}
            alt=''
            className={styles.fullScreenIcon}
            onClick={this.handleFullScreen}
          />
        </div>
      </main>
    );
  }
}

export default Main;
